import styled, { css } from "styled-components";
import { getToneTokens, PageActions, PageContainer, PageTitle, PageTopBar } from "../../styles/shared";

export const Wrapper = styled(PageContainer)``;

export const TopBar = styled(PageTopBar)``;

export const Title = styled(PageTitle)``;

export const Actions = styled(PageActions)``;

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  gap: 16px;
`;

export const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  border-radius: 8px;
  padding: 16px;
  display: grid;
  gap: 12px;
  min-width: 0;
`;

export const WidePanel = styled(Panel)`
  grid-column: 1 / -1;
`;

export const PanelTitle = styled.h2`
  font-size: 15px;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Label = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Value = styled.div`
  color: ${({ theme }) => theme.textPrimary};
  font-size: 13px;
  font-weight: 700;
  overflow-wrap: anywhere;
`;

export const Muted = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  line-height: 1.45;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Button = styled.button`
  min-height: 38px;
  border-radius: 8px;
  border: 1px solid ${({ theme, $variant }) => ($variant === "secondary" ? theme.border : theme.accent)};
  background: ${({ theme, $variant }) => ($variant === "secondary" ? theme.surface : theme.accent)};
  color: ${({ theme, $variant }) => ($variant === "secondary" ? theme.textSecondary : "#ffffff")};
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px 11px;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme, $variant }) => ($variant === "secondary" ? theme.accent : "#ffffff")};
  }

  &:disabled {
    opacity: 0.62;
    cursor: wait;
  }
`;

export const ThemeOption = styled(Button)`
  ${({ theme, $active }) =>
    $active &&
    css`
      background: ${theme.accent};
      border-color: ${theme.accent};
      color: #ffffff;
    `}
`;

// REF-14: seletor de cor de destaque. Mostra um disco com a cor + o nome.
// Ativo ganha borda na cor de destaque atual (var(--accent)).
export const AccentSwatch = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 6px 12px;
  border-radius: 8px;
  border: 2px solid ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textPrimary};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const AccentDot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $color }) => $color};
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.18);
`;

export const Message = styled.div`
  ${({ theme, $tone = "info" }) => {
    const tokens = getToneTokens(theme, $tone);
    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: anywhere;
`;
